export default "__VITE_ASSET__BOigo$X8__"